import { React, useEffect } from 'react';
import { Link } from 'react-router-dom';
import translate from '../translate';
import { useSelector } from 'react-redux';
import WOW from 'wowjs';
import $ from 'jquery'
import 'jquery.easing'
import 'owl.carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

function Services() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'services';

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init();
    }, []);

    useEffect(() => {
        
        // Initialize Owl Carousel after component is mounted
        window.$("[data-service-slider]").owlCarousel({
            loop: true,
            margin: 0,
            slideSpeed: 3000,
            nav: true,
            dots: false,
            navText: [
                "<i class='far fa-arrow-left'></i>",
                "<i class='far fa-arrow-right'></i>",
            ],
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    margin: 0,
                },
                768: {
                    items: 2,
                },
                1200: {
                    items: 3,
                },
                1440: {
                    items: 4,
                },
            },
        });
      }, []);

    return (
        <div className="service-section pt-125 pb-130">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="section-heading text-center mb-60 wow fadeInUp">
                        <span className="sub-heading">{translate(componentName, 'subHeading', language)}</span>
                        <h2 className="heading">{translate(componentName, 'heading', language)}</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="service-wrapper owl-carousel slide-nav" data-service-slider>
                        <div className="service-item wow fadeInUp">
                            <div className="icon">
                                <img src="assets/img/icons/service-icon-1.png" alt=""/>
                            </div>
                            <div className="content">
                                <h4 className="title"><Link to="/service-details">{translate(componentName, 'service1', language)}</Link></h4>
                                <Link to="/service-details" className="inline-btn">
                                    <i className="far fa-arrow-right"></i>
                                    <i className="far fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="service-item wow fadeInUp">
                            <div className="icon">
                                <img src="assets/img/icons/service-icon-2.png" alt=""/>
                            </div>
                            <div className="content">
                                <h4 className="title"><Link to="/service-details">{translate(componentName, 'service2', language)}</Link></h4>
                                <Link to="/service-details" className="inline-btn">
                                    <i className="far fa-arrow-right"></i>
                                    <i className="far fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="service-item wow fadeInUp">
                            <div className="icon">
                                <img src="assets/img/icons/service-icon-5.png" alt=""/>
                            </div>
                            <div className="content">
                                <h4 className="title"><Link to="/service-details">{translate(componentName, 'service3', language)}</Link></h4>
                                <Link to="/service-details" className="inline-btn">
                                    <i className="far fa-arrow-right"></i>
                                    <i className="far fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="service-item wow fadeInUp">
                            <div className="icon">
                                <img src="assets/img/icons/service-icon-6.png" alt=""/>
                            </div>
                            <div className="content">
                                <h4 className="title">
                                    <Link to="/service-details">{translate(componentName, 'service4', language)}</Link>
                                </h4>
                                <Link to="/service-details" className="inline-btn">
                                    <i className="far fa-arrow-right"></i>
                                    <i className="far fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-12 text-center">
                    <Link to="/service-details#service1" className="btn mt-60">{translate(componentName, 'viewAllServices', language)} <span></span></Link>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Services;



